import React from 'react';
import Icon from './ui-stubs';
import { Button } from './ui-stubs';
import { Input } from './ui-stubs';
import { Select } from './ui-stubs';

const PageHeader = ({ searchTerm, onSearchChange, selectedProject, onProjectChange, projects, onNewTask }) => {
  return (
    <div className="sticky top-0 z-40 bg-card border-b border-border shadow-sm">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between gap-4">
          {/* Left Section: Title */}
          <div className="flex items-center space-x-3">
            <Icon name="LayoutDashboard" size={28} className="text-primary" />
            <h1 className="text-2xl font-bold text-gray-900">Tasks</h1>
          </div>

          {/* Center Section: Project Selector & Search */}
          <div className="flex-1 max-w-2xl flex items-center gap-3">
            <div className="w-64">
              <Select
                value={selectedProject}
                onChange={onProjectChange}
                options={projects}
                placeholder="Select project"
              />
            </div>

            <div className="flex-1 relative">
              <Icon
                name="Search"
                size={18}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              />
              <Input
                type="text"
                placeholder="Search by task title, ID, or description..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e?.target?.value)}
                className="pl-10 w-full"
              />
            </div>
          </div>

          {/* Right Section: New Task Button */}
          <Button
            onClick={onNewTask}
            iconName="Plus"
            size="default"
            className="whitespace-nowrap"
          >
            New Task
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
